import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
// import { Row, Col } from 'react-bootstrap';
import Committeeleft from './Committeeleft';
import { Container, Row,Col } from 'react-bootstrap';
import Breadcrumb from '../../Breadcrumb/Main'
import { Table } from 'react-bootstrap';

function Main() {

    return (
        <>
            <Header />
            <Breadcrumb title='Home' subtitle="Disciplinary and Welfare Committee" />
            <section className="team-area fix p-relative pt-120 pb-80">
                <div className="container">
                    <div className="lower-content">

                        <Row>

                        <Col md={3} className='c-left custom-padding-color mb-4'>
                        <Committeeleft></Committeeleft>
                        </Col>
                
                        <Col md={9} className='c-right'>

                            
                                <h3 className='c-headline mb-3'>Disciplinary and Welfare Committee</h3>
                                <p className='c-lineheight2dot5'>A new cell for the Disciplinary and Welfare Committee has been constituted with the following members:  </p>

                                {/* <Link className='c-link' to="icc@iittp.ac.in" target="_blank" >icc@iittp.ac.in </Link> */}

                                <Table bordered responsive className='mt-3'>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <p>Dr. Gowri Asaithambi</p>
                                                <p>Associate Professor - Department of Civil & Environmental Engineering </p>
                                            </td>
                                            <td>Chairperson</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Dr. Vaneet Kashyap</p>
                                                <p>Associate Professor - Department of Humanities and Social Sciences
                                               
                                                </p>
                                            </td>
                                            <td> Convener</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Dr. Mamilla Ravi Sankar</p>
                                                <p>Professor - Department of Mechanical Engineering</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Dr. Vinay Pramod Majety</p>
                                                <p>Associate Professor - Department of Physics</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        
                                    </tbody>

                                </Table>

                               


                                <p className=' fw-bold c-headline caboutus mt-3 mb-3'>As per the Regulations of all the Academic programmes at IIT Tirupati, the terms of reference for this committee are :</p>
                                <ul className='ms-3 c-lineheight2dot5 iarrow caboutus' >
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> A Discipline and Welfare Committee has to be constituted by the Senate. Any act of indiscipline of a student reported to the Dean Academic Affairs, will be referred to a Discipline and Welfare Committee. The Committee will enquire into the charges and recommend suitable punishment if the charges are substantiated. The Senate will consider the recommendation of the Discipline and Welfare Committee for appropriate action.</li>
                                </ul>

                                </Col>

                           
                        </Row>

                    </div>
                </div>
            </section>
        </>
    )
}

export default Main;